import { useAppConfig } from "#imports";
export const useSanctumAppConfig = () => {
  return useAppConfig().sanctum ?? {};
};
